import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../api/axiosConfig";
import { blogImageSrc, COURSE_PLACEHOLDER } from "../api/blogImage";
import { usePurchases } from "../api/usePurchases";

const typeLabel = {
  "full-length": "Full Length",
  "subject-wise": "Subject Wise",
  "topic-wise": "Topic Wise",
};

function CourseDetail() {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const enrollTo = `/courses/${id}/pay`;
  const { loggedIn, loading: purchasesLoading, isPurchased } = usePurchases();
  const purchased = loggedIn && isPurchased(id);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    api
      .get(`/courses/${id}`)
      .then((res) => {
        if (!cancelled) {
          setCourse(res.data.course || null);
          setError(null);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setCourse(null);
          setError("Course not found.");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  if (loading) {
    return <p className="text-center py-5">Loading course...</p>;
  }

  if (!course) {
    return <p className="text-center py-5">{error || "Course not found."}</p>;
  }

  const tax = Number(course.tax_percentage);
  const price = course.priceLabel
    ? tax > 0
      ? `${course.priceLabel} + ${tax}% tax`
      : course.priceLabel
    : "Free";

  return (
    <main className="course-detail section-space">
      <div className="container">
        <p className="course-detail-back">
          <Link to="/courses">← All courses</Link>
        </p>

        <div className="course-detail-layout">
          <div>
            <img
              className="course-detail-banner"
              src={blogImageSrc(course.banner, COURSE_PLACEHOLDER)}
              alt=""
              onError={(event) => {
                event.target.onerror = null;
                event.target.src = blogImageSrc(null, COURSE_PLACEHOLDER);
              }}
            />
            <p className="course-type-badge">
              {typeLabel[course.course_type] || course.course_type}
            </p>
            <h1>{course.title}</h1>
            {course.category?.title ? (
              <p className="learn-card-instructor">{course.category.title}</p>
            ) : null}
            <h2 className="course-detail-heading">Description</h2>
            <div
              className="course-detail-copy"
              dangerouslySetInnerHTML={{
                __html: course.descriptionHtml || course.description || "",
              }}
            />
          </div>

          <aside className="course-detail-panel">
            <p className="course-detail-price">{price}</p>
            <dl className="course-detail-facts">
              <div>
                <dt>Full length tests</dt>
                <dd>{course.is_full_tests_available ? "Available" : "Not available"}</dd>
              </div>
              <div>
                <dt>Number of tests</dt>
                <dd>{Number(course.no_of_tests) || 0}</dd>
              </div>
            </dl>
            {course.includes?.length ? (
              <>
                <h2>This course includes</h2>
                <ul className="course-include-list">
                  {course.includes.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </>
            ) : null}
            {loggedIn && purchasesLoading ? (
              <span className="course-detail-enroll">Checking access...</span>
            ) : purchased ? (
              <Link to={`/my-courses/${id}`} className="btn-view-course course-detail-enroll">
                View course
              </Link>
            ) : (
              <Link to={enrollTo} className="btn-accent course-detail-enroll">
                Enroll Now
              </Link>
            )}
            {course.brochure ? (
              <a
                className="course-download-btn"
                href={blogImageSrc(course.brochure)}
                download
                target="_blank"
                rel="noreferrer"
              >
                Download brochure
              </a>
            ) : null}
          </aside>
        </div>
      </div>
    </main>
  );
}

export default CourseDetail;
